import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as SlotsPropertiesActions from "../../store/actions/Slots";

const instructions = [
  "Make sure the start_date is less than or equal to end_date",
  "start_date and end_date format is yyyy-mm-dd, i.e 2022-02-01",
  "Future date range can be added, it will exempt Star gigs for future date",
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const DriverStarGigsExemption = ({ getDriverStarGigsExemptionUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="driverStarGigsExemptionBtn"
      uploadUrl="/driver-shift/slot/bulk-driver-star-gigs-exempted/ack"
      sampleURL="/sample/bulk_driver_star_gigs_exemption.csv"
      id="driverStarGigsExemptionModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Star Gigs exemption upload (Driver)"
      getUploadUrl={getDriverStarGigsExemptionUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getDriverStarGigsExemptionUrl: bindActionCreators(
      SlotsPropertiesActions.getDriverStarGigsExemptionUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(DriverStarGigsExemption);
